import { checkJsonResult } from './util';

export const fetchResultList = ({ pointer = 0 } = {}) => fetch(
  `/api/reports?pointer=${pointer}`,
  {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    credentials: 'same-origin',
  },
).then(checkJsonResult);

export const fetchSingleResultList = ({ id }) => {
    const purl = '';
    // const purl = 'https://m-test.zhiyuntcm.com';
  const endpoint = id.startsWith('SR') ?purl+ `/api/share/${id}` : `/api/report/${id}`;
  return fetch(
    endpoint,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    },
  ).then(checkJsonResult);
};



// WEBPACK FOOTER //
// ./src/api/result-history.js